import { render, staticRenderFns } from "./adminRoomFeeList.vue?vue&type=template&id=513ffc2a&scoped=true"
import script from "./adminRoomFeeList.vue?vue&type=script&lang=js"
export * from "./adminRoomFeeList.vue?vue&type=script&lang=js"
import style0 from "./adminRoomFeeList.vue?vue&type=style&index=0&id=513ffc2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513ffc2a",
  null
  
)

export default component.exports